import { post } from '@/utils/request'

// 店铺列表
export function getShopList(data) {
  return post('admin/leifeng_shop_config/shopList', data)
}

// 店铺详情
export function getShopDetail(data) {
  return post('admin/leifeng_shop_config/shopDetail', data)
}

// 所有启用的店铺（下拉选择用）
export function getShopAllList(data) {
  return post('admin/leifeng_shop_config/shopAllList', data)
}

// 管理员列表
export function getAdminList(data) {
  return post('admin/leifeng_shop_config/adminList', data)
}

// 获取指定用户的店铺配置
export function getAdminShop(data) {
  return post('admin/leifeng_shop_config/getAdminShop', data)
}

// 为用户配置可访问的店铺
export function setAdminShop(data) {
  return post('admin/leifeng_shop_config/setAdminShop', data)
}

// 获取当前登录用户的店铺ID列表
export function getCurrentShop() {
  return post('admin/leifeng_shop_config/getCurrentShop')
}

// 获取当前登录用户的店铺列表（带详情）
export function getCurrentShopList(data) {
  return post('admin/leifeng_shop_config/getCurrentShopList', data)
}
